// Fills in the report-specific columns (rate, rate type, hours, total) as blank since a
// skipped assignment was never priced; the type_* columns follow the same convention.
export const buildSkippedRow = (skipped, types, columnKeys, sharedValues) => {
  const row = {
    [columnKeys.frequency]: sharedValues.frequency,
    [columnKeys.period]: sharedValues.period,
    consultant: skipped.userFullName,
    client: skipped.clientName,
    [columnKeys.rate]: '',
    [columnKeys.rateType]: '',
    [columnKeys.totalHours]: '',
    [columnKeys.total]: '',
    frozenTotal: '',
    computedTotal: '',
    status: `Skipped: ${skipped.reason}`
  }
  types.forEach(type => {
    row[`type_${type.timeTypeId}_hours`] = ''
    row[`type_${type.timeTypeId}_amount`] = ''
  })
  return row
}

export default buildSkippedRow
